<template>
    <div>
    <form class="content-form form-horizontal" @submit.prevent="submit()">
        <span style="color:#737373;"><i>Nota: El desarrollo actual admite obligatoriamente 3 instituciones. Todos los
                campos con * son obligatorios.</i></span>
        <hr>
        <div class="form-group"  >
            <label for="title" class="col-sm-3 control-label">Nombre Sección</label>
            <div class="col-sm-6">
               {{dataSection.title}}
            </div>
            <br><br>
        </div>
        <div class="form-group" :class="{'has-error': errors['title_section']}">
            <label for="title" class="col-sm-2 control-label">Titulo </label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="title_section" v-model="dataSection.title_section" >
                <div class="help-block" v-for="e in errors['title_section']">{{e}}</div>
            </div>
            <br><br>
        </div>
        <div class="form-group"  :class="{'has-error': errors['active']}">
            <label for="" class="col-sm-2 control-label">Activo</label>
            <div class="col-sm-10">
                <el-switch
                    v-model="dataSection.active"
                    on-text="SI"
                    off-text="NO"                    
                >
                </el-switch>
            </div>
            <br><br> 
        </div> 
        <div class="pading-to-vit">
            <div class="form-group">
                <label class="col-sm-2 control-label subtitle alin-text-label-tmp" style="color:cornflowerblue"><em>Vitrina P1</em></label>
            </div>
            <div class="form-group">
                <label for="titleVitrina1" class="col-sm-2 control-label alin-text-label-tmp">Inistitucion 1*</label>
                <div class="col-sm-10">
                    <institution-select id="institution_id_1" v-model="data[0].institution_id"
                        :institutions="this.institutions" class="col-sm-12"></institution-select>
                    <div class="help-block" v-for="e in errors['institution_id_1']">{{e}}</div>
                </div>
            </div>
            <div class="form-group" :class="{'has-error': errors['status']}">
                <label class="col-sm-4 control-label alin-text-label-tmp">¿Mostrar nombre corto?</label>
                <div class="col-sm-8">
                    <el-switch v-model="data[0].show_shortname" on-text="SI" off-text="NO"></el-switch>
                    <div class="help-block" v-for="e in errors['status']">{{e}}</div>
                </div>
            </div>
        </div>
        <hr>
        <div class="pading-to-vit">
            <div class="form-group">
                <label class="col-sm-2 control-label subtitle alin-text-label-tmp" style="color:cornflowerblue"><em>Vitrina P2</em></label>
            </div>
            <div class="form-group">
                <label for="titleVitrina1" class="col-sm-2 control-label alin-text-label-tmp">Inistitucion 2*</label>
                <div class="col-sm-10">
                    <institution-select id="institution_id_2" v-model="data[1].institution_id"
                        :institutions="this.institutions" class="col-sm-12"></institution-select>
                    <div class="help-block" v-for="e in errors['institution_id_2']">{{e}}</div>
                </div>
            </div>
            <div class="form-group" :class="{'has-error': errors['status']}">
                <label class="col-sm-4 control-label alin-text-label-tmp">¿Mostrar nombre corto?</label>
                <div class="col-sm-8">
                    <el-switch v-model="data[1].show_shortname" on-text="SI" off-text="NO"></el-switch>
                    <div class="help-block" v-for="e in errors['status']">{{e}}</div>
                </div>
            </div>
        </div>
        <hr>
        <div class="pading-to-vit">
            <div class="form-group">
                <label class="col-sm-2 control-label subtitle alin-text-label-tmp" style="color:cornflowerblue"><em>Vitrina P3</em></label>
            </div>
            <div class="form-group">
                <label for="titleVitrina1" class="col-sm-2 control-label alin-text-label-tmp">Inistitucion 3*</label>
                <div class="col-sm-10">
                    <institution-select id="institution_id_3" v-model="data[2].institution_id"
                        :institutions="this.institutions" class="col-sm-12"></institution-select>
                    <div class="help-block" v-for="e in errors['institution_id_3']">{{e}}</div>
                </div>
            </div>
            <div class="form-group" :class="{'has-error': errors['status']}">
                <label class="col-sm-4 control-label alin-text-label-tmp">¿Mostrar nombre corto?</label>
                <div class="col-sm-8">
                    <el-switch v-model="data[2].show_shortname" on-text="SI" off-text="NO"></el-switch>
                    <div class="help-block" v-for="e in errors['status']">{{e}}</div>
                </div>
            </div>
        </div>
        <hr>
        <div class="pading-to-vit">
            <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                    <a class="btn btn-default" href="backend/">Cancelar</a>
                    <button type="submit" class="btn btn-primary">Guardar</button>
                </div>
            </div>
        </div>
    </form>

     <div class="form-group scale">
        <div class="row">
            <label class="col-sm-2 control-label">Previsualización</label>
        </div>
        <div class="row">
            <div class="container">
                <div class="featured-area benef-serv">
                    <div class="container">
                        <div class="col-md-12 col-sm-12 col-xs-12">
                            <img class="gob" src="images/gob.svg" alt="Imagen de Gobierno de Chile">
                            <h2 class="h-tramites">
                                <span class="title-box">{{dataSection.title_section}}</span>
                            </h2>
                        </div>
                    
                        <div class="row">
                            <div class="container">
                                <div class="row mt-2">
                                    <div class="col-md-4 col-sm-12 col-xs-12">
                                        <div class="card">
                                            <h3 class="mb-2" v-if="data[0].institution_id">
                                                <a :href="'instituciones/'+data[0].institution_id">{{findInstitucion(data[0].institution_id).name}}
                                                    <div v-show="data[0].show_shortname">({{findInstitucion(data[0].institution_id).shortname}}) </div>  
                                                </a>
                                            </h3>
                                            <div>
                                                <span class="badge"  v-if="data[0].institution_id">{{findInstitucion(data[0].institution_id).nservices}}</span>
                                                <span class="text-primary">Servicios</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-sm-12 col-xs-12">
                                        <div class="card">
                                            <h3 class="mb-2" v-if="data[1].institution_id">
                                                <a :href="'instituciones/'+data[1].institution_id">{{findInstitucion(data[1].institution_id).name}}
                                                    <div v-show="data[1].show_shortname">({{findInstitucion(data[1].institution_id).shortname}}) </div> </a>
                                            </h3>
                                            <div>
                                                <span class="badge" v-if="data[1].institution_id">{{findInstitucion(data[1].institution_id).nservices}}</span>
                                                <span class="text-primary">Servicios</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-sm-12 col-xs-12">
                                        <div class="card">
                                            <h3 class="mb-2" v-if="data[2].institution_id">
                                                <a :href="'instituciones/'+data[0].institution_id">{{findInstitucion(data[2].institution_id).name}}
                                                    <div v-show="data[2].show_shortname">({{findInstitucion(data[2].institution_id).shortname}}) </div> </a>
                                            </h3>
                                            <div>
                                                <span class="badge" v-if="data[2].institution_id">{{findInstitucion(data[2].institution_id).nservices}}</span>
                                                <span class="text-primary">Servicios</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mt-20 mb-40 hidden-xs">
                                    <div class="col-md-4 col-sm-12 col-xs-12 benef-inst-text text-center">
                                    </div>
                                    <div class="col-md-4 col-sm-12 col-xs-12 benef-inst-text text-center">
                                    </div>
                                    <div class="col-md-4 col-sm-12 col-xs-12 text-right">
                                        <a class="btn btn-conoce" href="/instituciones">
                                            Conoce todas las instituciones
                                        </a>
                                    </div>
                                </div>

                                <div class="row mt-20 mb-40 hidden-md hidden-lg">
                                    <div class="col-md-4 col-sm-12 col-xs-12 benef-inst-text text-center">
                                    </div>
                                    <div class="col-md-4 col-sm-12 col-xs-12 mt-2 mb-2 benef-inst-text text-center">
                                    </div>
                                    <div class="col-md-4 col-sm-12 col-xs-12 text-center">
                                        <a class="btn btn-conoce" href="#">
                                            Conoce todas las instituciones
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>






</div> 
</template>
<style lang="scss" scoped>
    h3 {
        font-size: 20px !important;
        font-family: 'Roboto Slab';
        line-height: 1.1;
        font-weight: bold;

    }
    .mb-2{
        margin-bottom: 20px;
    }
    a {
        text-decoration: underline;
    }
    .scale{
        transform: scale(0.8);
    }
    .alin-text-label-tmp{
        text-align: left !important;
    }
    .benef-serv .badge {
        background: #0f69c4;
        font-size: 16px;
        font-family: 'Roboto Slab';
        padding: 8px 18px;
        border-radius: 25px;
    }
    .benef-inst-text {
        font-size: 14px;
        font-family: 'Roboto Slab';
        color: #707070;
    }
    .pading-to-vit{
        padding-top: 25px;
        padding-bottom: 25px;
    }
    .btn-conoce {
        background-color: transparent;
        border: 1px solid #0f69c4 !important;
        display: inline-block;
        color: #272727;
        padding: 11px 21px;
        margin: auto;
        font-family: Roboto Slab, sans-serif;
        text-decoration: none !important;
        font-size: 16px !important;
    }
</style>
<script>
import ElSwitch from 'element-ui/lib/switch';
import InstitutionSelect from './InstitutionSelect.vue';


export default {
    data: function () {
        var data = _.cloneDeep(this.vitrinas);
        var dataSection = _.cloneDeep(this.section);
        console.log('data', data)
        return {
            data: data,
            dataSection : dataSection,
            errors: {}
        }
    },
    props: ['vitrinas', 'institutions' , 'section'],
    components: {
        ElSwitch,
        InstitutionSelect
    },
    methods: {
            submit: function () {
                var self = this;
                var errores = {};


                if (!self.data[0].institution_id) {
                    errores["institution_id_1"] = ["Debe ingresar una institución en la primera posicion."];
                }
                if (!self.data[1].institution_id) {
                    errores["institution_id_2"] = ["Debe ingresar una institución en la segunda posicion."];
                }
                if (!self.data[2].institution_id) {
                    errores["institution_id_3"] = ["Debe ingresar una institución en la tercera posicion."];
                }

                if (!self.dataSection.title_section) {
                    errores['title_section'] = ["Debe ingresar un titulo se la sección"];
                }
                if (/^\s+$/.test(self.dataSection.title_section)){
                  errores['title_section'] = ["El título de la sección debe no pueder ser solo espacios en blanco"];
                }

                let datatmp = {};
                datatmp['data_inst'] = self.data;
                datatmp['section'] = self.dataSection;
                //self.data = datatmp;

                if (_.size(errores) > 0) {

                    self.errors = errores;
                    console.log('errores a  mostrar ' , this.errors)
                    self.$message.error(
                    "Revise los errores en el formulario para continuar."
                    );
                    return false;
                }else{
                    this.errors = {};
                    console.log('pruebas' , self.data)
                    axios({
                        url: 'backend/vitrina-beneficios-servicios-up',
                        method: 'POST',
                        data: datatmp
                    }).then((response) => {
                        console.log(response);
                        window.location.replace(response.data.redirect);
                    }).catch((error) => {
                        self.errors = error.response.data.errors;
                    });
                }
            },
            findInstitucion:function (id) {
                var institucion = this.institutions.find(ins => ins.id === id);
                return institucion;
            }
        }

}
</script>